import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api.service';
import moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { from } from 'rxjs';
import { CommonService } from '../../service/common.service';
import { vesselContent } from '../../../../../website/src/app/tools/constant';

@Component({
  selector: 'app-vessel-schedule',
  templateUrl: './vessel-schedule.component.html',
  styleUrl: './vessel-schedule.component.css'
})
export class VesselScheduleComponent implements OnInit {

  loading: boolean = false;
  portList = <any>[];
  searchObj = {
    from: <any>null,
    to: <any>null,
    open_from: false,
    open_to: false,
    from_date: <any>null,
    to_date: <any>null,
    filter_type: <any>'departure',
    liners: <any>[],
    nf: 0,
    nt: 0
  };
  getObj = {
    from: <any>'',
    to: <any>'',
    sort_by: 'earliest_departure'
  };
  validateError: any = {};
  VesselDataList: any = [];
  rateData: any = [];
  reqfield: any = ['from', 'to', 'filter_type', 'from_date', 'to_date'];

  queryParamsSubscribe: any;
  queryParamsData: any;
  dateValidation = {
    fromMin: new Date(),
    toMin: new Date(),
  }
  optionList = {
    containerList: <any>[],
    linerList: <any>[]
  }
  sortList = [
    { name: 'fastest_transit', dname: 'Quickest Transit Time' },
    { name: 'earliest_departure', dname: 'Earliest Departure' },
    // { name: 'earliest_arrival', dname: 'Earliest Arrival' },
  ];


  constructor(private apiPortalService: ApiService, private activeRoute: ActivatedRoute,
    private route: Router, private commonService: CommonService,) { }
  ngOnInit(): void {
    // this.queryParamsSubscribe = this.activeRoute.queryParams.subscribe(params => {
    //   this.searchObj.from = this.activeRoute.snapshot.paramMap.get('origin');
    //   this.searchObj.to = this.activeRoute.snapshot.paramMap.get('destination');
    //   this.searchObj.from_date = params['from'];
    //   this.searchObj.to_date = params['to']
    //   this.searchObj.filter_type = params['filter_type'] ? params['filter_type'] : this.searchObj.filter_type;
    //   this.search();
    // });

    this.queryParamsSubscribe = this.activeRoute.paramMap.subscribe(paramMap => {
      this.searchObj.from = paramMap.get('origin');
      this.searchObj.to = paramMap.get('destination');
    });

    this.activeRoute.queryParams.subscribe(params => {
      this.searchObj.from_date = params['from'];
      this.searchObj.to_date = params['to'];
      this.searchObj.filter_type = params['filter_type'] || this.searchObj.filter_type;
      if (this.searchObj.from && this.searchObj.to) {
        this.search();
      }
    });

    this.setDefaultDates();
    this.onResize();
    this.getService();
  }

  getService() {
    this.apiPortalService.getRateSearchInit().subscribe(res => {
      if (res.statusCode == 200) {
        this.optionList.containerList = res.info.containers;
        this.optionList.linerList = res.info.liners;
      }
    })
  }

  search() {
    this.searchObj.from_date = this.searchObj.from_date ? moment(this.searchObj.from_date).format('YYYY-MM-DD') : null;
    this.searchObj.to_date = this.searchObj.to_date ? moment(this.searchObj.to_date).format('YYYY-MM-DD') : null;
    const hasValidationError = Object.values(this.validation()).some(error => error);
    if (!hasValidationError) {
      this.loading = true;
      let queryParam = {};
      let body = {
        origin: this.searchObj?.from?.id ? this.searchObj?.from?.id : this.searchObj?.from,
        destination: this.searchObj?.to?.id ? this.searchObj?.to?.id : this.searchObj?.to,
        from: this.searchObj.from_date ? this.searchObj.from_date : null,
        to: this.searchObj.to_date ? this.searchObj.to_date : null,
        filter_type: this.searchObj.filter_type,
        liners: !!this.getObj["liners"] ? this.getObj["liners"] : '',
        sort_by: this.getObj.sort_by,
        nf: this.searchObj.nf ? this.searchObj.nf : 0,
        nt: this.searchObj.nt ? this.searchObj.nt : 0,
      }
      if (!!body.from && !!body.to && !!body.filter_type) {
        queryParam['from'] = body.from;
        queryParam['to'] = body.to;
        queryParam['filter_type'] = body.filter_type;
      }
      this.apiPortalService.getVesselSchedule(body).subscribe((res) => {
        if (res.statusCode == 200) {
          if (res.statusCode == 200) {
            this.VesselDataList = res.info.schedule;
            this.queryParamsData = res.info.query_params;
            this.loading = false;
          }
        }
      });
      // this.route.navigate(['main/vessel-schedule', body.origin, body.destination], { queryParams: queryParam });
    }
  }

  swape() {
    let obj = JSON.parse(JSON.stringify(this.searchObj));
    this.searchObj.to = obj.from;
    this.searchObj.from = obj.to;
  }

  getPortSearch(q: any) {
    if (!!q) {
      q = q.value;
    }
    let obj = {
      "q": q,
      "limit": "10",
      "type": "port"
    };
    this.apiPortalService.getCommonOption(obj).subscribe(res => {
      if (res.statusCode == 200) {
        this.portList = res.info;
        this.openFirstNearBy();
        this.portList = res.info.map(i => {
          i.isMatch = this.searchObj.from?.location_name === i.location_name || this.searchObj.to?.location_name === i.location_name;
          return i;
        });
      }
    })
  }
  openFirstNearBy() {
    this.portList.forEach((i, index) => {
      if (!!i.nearby_ports && !!i.nearby_ports.length && !index) {
        i['open'] = true;
      }
    });
    // this.fromToOptionListObj.to.forEach((i, index) => {
    //   if (!!i.nearby_ports && !!i.nearby_ports.length && !index) {
    //     i['open'] = true;
    //   }
    // });
  }

  chooseLocation(type, value) {
    if (type == 'from') {
      this.searchObj.from = value;
      this.searchObj.open_from = false;
      this.getObj.from = value.id + '';
    } else {
      this.searchObj.to = value;
      this.searchObj.open_to = false;
      this.getObj.to = value.id + '';
    }
  }

  validation() {
    this.validateError = this.commonService.validation(this.searchObj, this.reqfield);
    return this.validateError;
  }

  setDefaultDates(): void {
    const today = new Date();
    const afterTwoWeeks = new Date(today);
    afterTwoWeeks.setDate(today.getDate() + 14);
    this.searchObj.from_date = this.searchObj.from_date ? this.searchObj.from_date : today.toISOString();
    this.searchObj.to_date = this.searchObj.to_date ? this.searchObj.to_date : afterTwoWeeks.toISOString();
  }


  displayFnPortValue(option): string {
    let value = "";
    if (!!option && !!option?.location_type && option?.location_type == 'zipcode') {
      value = option.name + (!!option?.postal_code ? (" - " + option?.postal_code) : "")
    } else
      if (!!option && !!option?.location_name) {
        value = option.location_name + (!!option?.location_code ? (" - " + option?.location_code) : "")
      }
    return value;
  }

  selectInputValue(inputElement: HTMLInputElement): void {
    inputElement.select();
  }

  autoCompletePannelWidth = 'max-width';
  onResize() {
    this.autoCompletePannelWidth = this.commonService.autoCompletePannelWidth();
  }

  clearFilter(type) {
    if (type == "liner") {
      this.searchObj.liners = [];
      this.optionList.linerList.forEach(i => {
        i["checked"] = false;
      });
    }
    this.getObj["liners"] = '';
    this.searchObj.liners = [];;
    this.search();
  }
  selectedLiner(listInput) {
    let liner = <any>[];
    // console.log(listInput)
    let linerObjLit = <any>[];
    listInput.forEach(i => {
      if (i.checked) {
        liner.push(i.id + '');
        linerObjLit.push(i);
      }
    });

    if (liner.length) {
      this.getObj["liners"] = liner + '';
      this.searchObj.liners = linerObjLit;
    } else {
      this.getObj["liners"] = '';
      this.searchObj.liners = [];
    }

    this.search();
  }
  afterSelectLocation(inputType){
    if (!!this.searchObj[inputType] && !!this.searchObj[inputType].nearby_ports && !!this.searchObj[inputType]?.nearby_ports.length) {
      inputType == 'to' ? (this.searchObj.nt = 1) : (this.searchObj.nf = 1);
    } else {
      inputType == 'to' ? (this.searchObj.nt = 0) : (this.searchObj.nf = 0);
    }
  }
}